module.exports = __webpack_public_path__ + "images/pages/for_business/pc/btn_6_bf9a498853596cedfb8ad0ac77d2f85f.png";